import { render, staticRenderFns } from "./myprofile-nav.vue?vue&type=template&id=18846b1b"
import script from "./myprofile-nav.vue?vue&type=script&lang=js"
export * from "./myprofile-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports